
import { useEffect } from "react";
import EnhancedLandingPage from "./EnhancedLandingPage";

export function LandingPage() {
  useEffect(() => {
    // Track landing page view
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: 'Landing Page',
        page_location: window.location.href,
        page_path: window.location.pathname
      });
      console.log('[Analytics] Landing page view tracked');
    }

    // Preload signup page image for faster loading
    const signupImage = new Image();
    signupImage.src = "/lovable-uploads/6942857d-3f06-4316-94e2-2fc64e3b2e9a.png";
  }, []);

  return <EnhancedLandingPage />;
}
